import { AnalysisResult, ApiProvider } from '../types';
import { analyzeImageWithGrokAPI } from './apiService';
import { formatAnalysisForDisplay } from './analysisUtils';

/**
 * Web-specific Grok analysis service
 * Provides a standardized interface for xAI Grok-4 vision analysis in the web app
 */
export const analyzeImageWithGrok = async (
  imageUrl: string
): Promise<AnalysisResult> => {
  try {
    const result = await analyzeImageWithGrokAPI(imageUrl);

    // Ensure the result has the correct structure for web display
    return formatAnalysisForDisplay({
      ...result,
      apiProvider: ApiProvider.GROK,
    });
  } catch (error) {
    console.error('Error during Grok analysis:', error);
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred while analyzing with Grok.';
    throw new Error(`Grok API Error: ${errorMessage}`);
  }
};
